import numeral from 'numeral'
import dayjs from 'dayjs'

global.numeral = numeral
global.dayjs = dayjs
